module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAvCAYAAADeposFAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAvSURBVHgB7dBBAQBABAVRtspWEUJBtURBA+78Ob/TsJskNT0a2gH4a+ADAADAYVBHtAWbtlBEawAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Group.png
// module id = eo5J
// module chunks = 17